import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FullscreenService {
    isFullscreen = signal(true);

    toggleFullscreen(): void {
        this.isFullscreen.set(!this.isFullscreen());
    }
}
